module.exports = __webpack_public_path__ + "static/img_pledge_children_01M@2x-c54bb2acc72d2d60240ecb9f3522ecaf.png";